import {createBrowserRouter, Navigate} from "react-router-dom";
//import Login from "./components/Login.js";'
import Login from "./jsx/pages/Login";
import Login1 from "./components/Login1";
import ProfitPage from "./components/ProfitPagek.js";
import UserPage from "./components/UserPage.js";

import OpeningBalances from "./components/OpeningBalances.js";

import Areas from "./components/city.js";
import StorageType from "./components/StorageType.js";
import ProcessStatus from "./components/ProcessStatus.js";
import Guaranteetype from "./components/GuaranteeType.js";
 import Parts from "./components/WeddingHall.js";
import Empolyee from"./components/Employee.js";
import EditRepairOrder from "../src/jsx/constant/EditRepairOrder.js";
import OrdersList from "./components/Orders.js";
import Alasnaf from "./components/Al-Asnaf.js";
import AsnafReport from "./components/AsnafReport.js";
import Suppliers from "./components/Suppliers.js";
import MainCompany from "./components/MainCompany.js";
import EditWeddingHall from "../src/jsx/constant/edit.js";
import ToolsReport from "./components/ToolsReport.js";
import Dashboard from "./components/Dashboard_1";
import MainPage from "./components/MainPage.js";
import GuestLayout from "./components/GuestLayout";
import CompanyExpenses from "./components/CompanyExpenses";
import NotFound from "../src/jsx/pages/Error404.js";
import Company from './components/Company.js';
import Invoice from './components/InvoiceRepairOrder.js';
import OrderCheckout from './components/OrderCheckout';
import IntTypes from './components/IntTypes.js';
import ExpenseTypes from './components/ExpenseTypes.js';
 import Customers from './components/customers.js';
import Atbak from './components/Atbak.js';
import First from './components/charts/index.js';
 import CompanyPurchases from "./components/CompanyPurchases";
import Income from "./components/Income";
import NotConfirmedOrder from "./components/NotConfirmedOrder";
import CutomerPageInfo from "./components/CutomerPageInfo";

import NotConfirmedOrdercheckout from "./components/NotConfirmedOrdercheckout";
import NotConfirmedInvoice from "./components/NotConfirmedInvoice";
import Car from "./components/car.js";
import EmployeeStatus from "./components/EmployeeStatus";

 
import Expensesreport from "./components/CompanyExpensesreport";
import FormValidation from "./components/FormValidation";
import DateLimitation from "./components/AllOrderDateLimits.js";
import ManageUsers from "./components/Orderss copy.js";
import EditCompany from "./components/Company copy.js";
import AddCompany from "./components/Company.js";
 import Maintainreport from "./components/maintainreport.js";
 import Ingredients from './components/Ingredients.js';
 import NextMaintainceDate from './components/NextMaintainceDate.js';
 import CachSystem from './components/CachSystem.js';
 import FixedAssetsPage  from './components/FixedAssetsPage.js';
 import AccountPage  from './components/AccountPage.js';
 import JournalEntryPage  from './components/JournalEntryPage.js';
 import DepreciationPage  from './components/DepreciationPage.js';
 import BalanceSheet  from './components/BalanceSheet.js';
 import ProfitLossPage from './components/ProfitLossPage.js';
 import TrialBalancePage  from './components/TrialBalancePage.js';
 import AccountTree  from './components/AccountTree.js';
 import ConstructionExpensesPage  from './components/ConstructionExpensesPage.js';
 import JournalWithTree  from './components/JournalWithTree.js';
import Userlog from "./components/UserLog.js";
import Notifications from "./components/Notificatons.js";

import Garantees from "./components/Garantees.js";

const router = createBrowserRouter([
  {
    path: '/',
    element: <MainPage/>,
    children: [
      {
        path: '/',
        element: <Dashboard/>
      },
      {
        path: '/DateLimitation',
        element: <DateLimitation/>
      },
       {
        path: '/JournalWithTree',
        element: <JournalWithTree/>
      },
        {
        path: '/Userlog',
        element: <Userlog/>
      },
      {
        path: '/OpeningBalances',
        element: <OpeningBalances/>
      },
      {
        path: '/Notifications',
        element: <Notifications/>
      },
      {
        path: '/AccountTree',
        element: <AccountTree/>
      },
        {
        path: '/DepreciationPage',
        element: <DepreciationPage/>
      },
      {
        path: '/AccountPage',
        element: <AccountPage/>
      },{
        path: '/ConstructionExpensesPage',
        element: <ConstructionExpensesPage/>
      },
      {
        path: '/BalanceSheet',
        element: <BalanceSheet/>
      },
       {
        path: '/TrialBalancePage',
        element: <TrialBalancePage/>
      },
       {
        path: '/ProfitLossPage',
        element: <ProfitLossPage/>
      },
       {
        path: '/JournalEntryPage',
        element: <JournalEntryPage/>
      },
       {
        path: '/NextMaintainceDate',
        element: <NextMaintainceDate/>
      },
       {
        path: '/FixedAssetsPage',
        element: <FixedAssetsPage/>
      },
      {
        path: '/CachSystem',
        element: <CachSystem/>
      },
       {
        path: '/EmployeeStatus',
        element: <EmployeeStatus/>
      },
      {
        path: '/ProfitPage',
        element: <ProfitPage/>
      },
     
      {
        path: '/AddCompany',
        element: <AddCompany/>
      },
      {
        path: '/EditCompany',
        element: <EditCompany/>
      },
      {
        path: '/Ingredients',
        element: <Ingredients/>
      },
      {
        path: '/ManageUsers',
        element: <ManageUsers/>
      },
       {
        path: '/NotConfirmedOrder/:CustomerID',
        element: <NotConfirmedOrder/>
      },
     
      {
        path: '/car/:VehicleID',
        element: <Car/>
      },
      {
        path: '/Garantees',
        element: <Garantees/>
      },
      {
        path: '/NotConfirmedInvoice',
        element: <NotConfirmedInvoice/>
      },
      {
        path: '/NotConfirmedOrdercheckout',
        element: <NotConfirmedOrdercheckout/>
      },
      {
        path: '/MainCompany',
        element: <MainCompany/>
      },
      {
        path: '/FormValidation',
        element: <FormValidation/>
      },
      {
        path: '/CompanyExpensesreport',
        element: <Expensesreport/>
      },
      
      {
        path: '/Atbak',
        element: <Atbak/>
      },
      {
        path: '/IntTypes',
        element: <IntTypes/>
      },
      {
        path: '/Income',
        element: <Income/>
      },
      {
        path: '/ExpenseTypes',
        element: <ExpenseTypes/>
      },
      {
        path: '/CompanyPurchases',
        element: <CompanyPurchases/>
      },
      
      {
        path: '/First',
        element: <First/>
      },
      {
        path: '/Dashboard_1',
        element: <Dashboard/>
      },
      {
        path: '/Invoice',
        element: <Invoice/>
      },
      {
        path: '/Parts',
        element: <Parts/>
      },
       {
        path: '/WeddingHall/edit/:id',
        element: <EditWeddingHall/>
      },
      {
        path: '/EditRepairOrder/:repairOrderId',
        element: <EditRepairOrder/>
      },
      {
        path: '/maintainreport/:repairOrderId',
        element: <Maintainreport/>
      },
      {
        path: '/Customers',
        element: <Customers/>
      },
      {
        path: '/Company',
        element: <Company/>
      },
      {
        path: '/CompanyExpenses',
        element: <CompanyExpenses/>
      },
      {
        path:'/Suppliers',
  
        element: <Suppliers/>
      },
      {
        path: '/AsnafReport',
        element: <AsnafReport/>
      },
      {
        path: '/Empolyee',
        element: <Empolyee/>
      },
      {
        path: '/StorageType',
        element: <StorageType/>
      },
      {
        path: '/guaranteetype',
        element: <Guaranteetype/>
      },
      {
        path: '/ProcessStatus',
        element: <ProcessStatus/>
      },
      {
        path: '/ToolsReport',
        element: <ToolsReport/>
      },
     
      {
        path: '/OrdersList',
        element: <OrdersList/>
      },
      {
        path: '/Al-asnaf',
        element: <Alasnaf/>
      },
      {
        path: '/city',
        element: <Areas/>
      },
     
      {
        path: '/OrderCheckout',
        element: <OrderCheckout/>
      }
    ]
  },
  {
    path: '/',
    element: <GuestLayout/>,
    children: [
      {
        path: '/login1',
        element: <Login1/>
      },
      {
        path: '/login',
        element: <Login/>
      },
      {
        path: '/UserPage',
        element: <UserPage/>
      },
     
       {
        path: '/CutomerPageInfo/',
        element: <CutomerPageInfo/>
      },
    ]
  },
  {
    path: "*",
    element: <NotFound/>
  }
])

export default router;


